import { FC } from 'react'

import {
  AgGridFilterType,
  AgGridFilters,
  FilterChip,
  FilterDef,
} from '../agGridFilters.types'
import { Chip, Container, NoFilters, StyledIcon } from './selectedFilters.ui'
import { getFilterChipLabel, getFilterChipValue } from './selectedFilters.utils'

export const SelectedFiltersTestIds = {
  icon: 'selected-filters-icon-delete',
}

type Props = {
  filterDefs: FilterDef[]
  filters: AgGridFilters<string>
  onRemoveFilter: (name: string, value: string) => void
}

export const SelectedFilters: FC<Props> = ({
  filterDefs,
  filters,
  onRemoveFilter,
}) => {
  const selectedFilters = Object.entries(filters).reduce<FilterChip[]>(
    (acc, [name, filter]) => {
      if (filter.filterType === AgGridFilterType.Set) {
        return [
          ...acc,
          ...filter.values.map((value) => ({
            name,
            label:
              filterDefs.find((filterDef) => filterDef.name === name)?.label ??
              name,
            filterType: filter.filterType as AgGridFilterType,
            value,
          })),
        ]
      }

      return [
        ...acc,
        {
          name,
          label:
            filterDefs.find((filterDef) => filterDef.name === name)?.label ??
            name,
          filterType: filter.filterType as AgGridFilterType,
          value: getFilterChipValue(filter),
        },
      ]
    },
    [],
  )

  return (
    <Container $hasSelection={selectedFilters.length > 0}>
      {selectedFilters.length ? (
        selectedFilters.map((filter) => (
          <Chip key={`${filter.name}-${filter.value}`}>
            {`${getFilterChipLabel(filter)} ${filter.value}`}
            <StyledIcon
              iconName="x-close"
              iconSize="small"
              plain
              onClick={(): void => onRemoveFilter(filter.name, filter.value)}
              data-testid={`${SelectedFiltersTestIds.icon}-${filter.name}`}
            />
          </Chip>
        ))
      ) : (
        <NoFilters>No Filters Selected</NoFilters>
      )}
    </Container>
  )
}
